<template>
	<div style="display: flex; flex-direction: column; width: 100%;">
		<div v-if="displayedContent || (displayedContentArr && displayedContentArr.length > 0)" style="background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; flex-direction: column; margin-top: 15px; display: flex; width: 100%;">
			
			<div v-if="dataIndex == 2 && !isRandom">
				<img style="width: 60px; height: 60px; margin-top: 10px; margin-left: 10px;" draggable="false" src="../../assets/icon_home_ai_logo_2.gif" alt="" />
				<div style="display: flex; justify-content: space-between; padding: 20px 20px 14px 20px; margin-top: -25px;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: rgba(31, 38, 53, 1); line-height: 22px;">{{ this.$props.data.title ? this.$props.data.title : (this.$props.data.text ? this.$props.data.text : '') }} </div>
					<!-- <img v-if="!isUnfold" style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false"  @click="clickUnflod" />
					<img v-if="isUnfold"  style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3.png" alt="" draggable="false"  @click="clickUnflod" /> -->
				</div>
			</div>

			<div v-if="dataIndex == 2 && isRandom" style="display: flex; justify-content: space-between; padding: 20px 20px 14px 20px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">{{ this.$props.data.title ? this.$props.data.title : (this.$props.data.text ? this.$props.data.text : '') }} </div>
				<img v-if="!isUnfold" style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false"  @click="clickUnflod" />
				<img v-if="isUnfold"  style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3.png" alt="" draggable="false"  @click="clickUnflod" />
			</div>

			<div v-if="dataIndex != 2" style="display: flex; justify-content: space-between; padding: 20px 20px 14px 20px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #1F2635; line-height: 22px;">{{ this.$props.data.title ? this.$props.data.title : (this.$props.data.text ? this.$props.data.text : '') }} </div>
				<img v-if="!isUnfold" style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false"  @click="clickUnflod" />
				<img v-if="isUnfold"  style="width: 24px; height: 24px; cursor: pointer;" src="../../assets/icon_home_ai_icon_3.png" alt="" draggable="false"  @click="clickUnflod" />
			</div>

			<div v-if="isUnfold" style="height: 1px; background: rgba(94, 103, 121, 0.1); margin-left: 20px; margin-right: 20px;"></div>
			
			<div v-if="displayedContent && isUnfold" style="padding-left: 20px; padding-right: 20px; margin-top: 15px;">
					<div v-html="displayedContent" style="color: rgba(160, 208, 231, 1);"></div>
			</div>

			<div v-for="(item, index) in displayedContentArr">
				<!-- 深度思考部分 -->
				<div v-if="item.isDepth == true && isUnfold" class="deepThinking" :style="{ marginTop: '15px'}">
					<div style="display: flex; align-items: center; justify-content: space-between; height: 40px; cursor: pointer;" @click="clickUnflod1(index)">
						<div style="display: flex; align-items: center;">
							<img style="width: 16px; height: 16px; cursor: pointer; margin-left: 15px;" src="../../assets/icon_ai_depth_icon_1.png" alt="" />
							<div style="margin-left: 4px; font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: rgba(94, 103, 121, 1); line-height: 20px;">{{ item.isFinishDepth ? '已深度思考' : '思考中...' }}</div>
						</div>
						<img v-if="(deepThinkingIsUnfoldArr && deepThinkingIsUnfoldArr.length - 1 >= index && deepThinkingIsUnfoldArr[index] == 'fold')" style="width: 24px; height: 24px; cursor: pointer; margin-right: 15px;" src="../../assets/icon_home_ai_icon_3_1.png" alt="" draggable="false" />
						<img v-if="(deepThinkingIsUnfoldArr && deepThinkingIsUnfoldArr.length - 1 >= index && deepThinkingIsUnfoldArr[index] == 'unfold')"  style="width: 24px; height: 24px; cursor: pointer; margin-right: 15px;" src="../../assets/icon_home_ai_icon_3_2.png" alt="" draggable="false" />
					</div>


					<div v-if="(deepThinkingIsUnfoldArr && deepThinkingIsUnfoldArr.length - 1 >= index && (deepThinkingIsUnfoldArr[index] == 'have' || deepThinkingIsUnfoldArr[index] == 'unfold'))" style="padding-left: 35px; padding-right: 15px; margin-top: 7px; margin-bottom: 1px; overflow: hidden;">
						<div v-html="item.content" style="color: rgba(94, 103, 121, 0.5); font-weight: 400; font-size: 14px; line-height: 20px;"></div>
					</div>
				</div>

				<!-- 主部分 -->
				<div v-if="item.isDepth == false && isUnfold" style="margin-top: 15px; margin-left: 20px; margin-right: 20px; overflow: hidden;">
					<div v-html="item.content" style="color: rgba(94, 103, 121, 1); font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 16px;"></div>
				</div>
			</div>

			<div v-if="isUnfold" style="display: flex; padding-left: 20px; padding-right: 20px; margin-bottom: 15px; justify-content: space-between; align-items: center;">
				<div style="flex: 1;"></div>
				<div v-if="isFinish" class="copy_share" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px; display: flex;">
					<div class="copy_share_copyBtn" style="display: flex; width: 66px; height: 30px; justify-content: center; align-items: center; border-radius: 5px; cursor: pointer; margin-right: 5px;" @click="clickCopyText()">
						<div class="copy_share_copoyImage" style="width: 16px; height: 16px; margin-right: 2px;" draggable="false" />
						<div class="copy_share_copyText" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px;">复制</div>
					</div>
					<div id="shareContent" class="copy_share_shareBtn" style="display: flex; width: 66px; height: 30px; justify-content: center; align-items: center; border-radius: 5px; cursor: pointer; position: relative;" @click="share()">
						<div class="copy_share_shareImage" style="width: 16px; height: 16px; margin-right: 2px; background: green;"></div>
						<div class="copy_share_shareText" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #9EA4AF; line-height: 20px;">分享</div>
						<div v-if="isShowQrCode" style="position: absolute; height: 221px; width: 200px; bottom: 27px; right: 0px;" @click.stop>
							<img style="position: absolute; width: 52px; height: 31px; bottom: -1px; right: 7px; z-index: 0;" src="../../assets/icon_home_ai_icon_11.png" alt="" draggable="false" />
							<div v-loading="qrCodeIsLoading" style="display: flex; justify-content: center; align-items: center; position: absolute; width: 200px; height: 200px; background: #FFFFFF; box-shadow: 0px 0px 10px 0px rgba(192,197,202,0.8); border-radius: 8px; z-index: 1;">
								<div id="qrCode" ref="qrCodeDetails"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="questions && questions.length > 0" style="display: flex; flex-direction: column; padding-left: 20px; padding-right: 20px; padding-bottom: 20px;">
				<div style="height: 1px; background: rgba(94, 103, 121, 0.1);"></div>
				<div style="display: flex; align-items: center; margin-top: 15px;">
					<img style="width: 16px; height: 16px; margin-right: 5px;" src="../../assets/icon_home_ai_icon_16.png" alt="" draggable="false" />
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #4A7CE8; line-height: 20px;">猜你想问</div>
				</div>
				<div style="display: flex; flex-direction: column;">
					<div v-for="(item, index) in questions || []" style="background: rgba(74, 124, 232, 0.2); border-radius: 20px 20px 20px 2px; backdrop-filter: blur(8px); display: flex; align-items: center; padding: 10px; align-self: flex-start; margin-top: 10px; cursor: pointer;" @click="clickAiQuestion(item)">
						<div style="width: 10px; height: 10px; border: 2px solid rgba(74, 124, 232, 0.5); border-radius: 5px; margin-right: 5px;"></div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #5E6779; line-height: 20px;">{{item}}</div>
					</div>
				</div>
			</div>

			<div v-if="toastStr" style="position: absolute; background: rgba(0, 0, 0, 0.5); border-radius: 8px; backdrop-filter: blur(8px); padding: 15px; display: flex; justify-content: center; align-items: center; left: 50%; top: 50%; transform: translate(-50%, -50%);">
				<img style="width: 16px; height: 16px; margin-right: 5px;" src="../../assets/icon_home_ai_icon_10.png" alt="" draggable="false" />
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 16px; color: #FFFFFF; line-height: 22px;">{{ toastStr }}</div>
			</div>
		</div>
		<div v-if="isLoading" style="display: flex;  height: 120px; background: #FFFFFF; box-shadow: 0px 0px 10px 0px #D9E7F1; border-radius: 2px 12px 12px 12px; margin-top: 15px; overflow: hidden;" v-loading="isLoading" element-loading-text="AI分析中，请稍候..." class="loadingContent"></div>
	</div>
</template>
  
<script>

import {marked} from 'marked'
import QRCode from "qrcodejs2";
import axios from 'axios';
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';

export default {
	props: {
		data: {
			type: Object,
			default: null
		},
		dataIndex: {
			type: Number,
			default: null
		},
		msgArr: {
			type: Array,
			default: null
		},
		shareTitle: {
			type: String,
			default: ''
		},
		shareSubTitle: {
			type: String,
			default: ''
		},
		modelValue: null,
		isRandom: null
	},
	computed: {
	},
	watch: {
		
	},
	data() {
		return {

			isUnfold: true,

			rawContent: '',
			displayedContent: '',
			interval: null,
			index: 1,

			toastStr: null,
			isShowQrCode: false,
			qrCodeIsLoading: false,

			isLoading: true,
			questions: null,

			jsonArr: [],
			isFinish: false,
			analysisString: '',


			eventSource: null,
			clientId: null,
			isRequestServerInterface: false, // 是否发起过接口打字的网络请求
			isPrint: false, // 是否开始打字
			isDataFull: false, // 字符串数据是否完整了
			wholeContent: '',

			isStopPrint: false, // 是否停止打字

			displayedContentArr: null, // 显示内容数组

			deepThinkingIsUnfoldArr: [],

		};
	},
	created() {
		// 监听整个文档的点击事件
		let that = this;
		document.addEventListener('click', function (event) {
			// 检查点击是否发生在特定元素之外
			let qrCodeContainer = document.getElementById('shareContent');
			const isClickInsideElement = qrCodeContainer && qrCodeContainer.contains(event.target);
			if (!isClickInsideElement) {
				that.isShowQrCode = false;
			} else {

			}
		});
	},
	mounted() {
		this.$nextTick(() => {
			console.log('===传入的参数===', this.$props.data);
			// if (this.$props.data.text && this.$props.data.text != '帮我解读“当日需及时关心的长者”') {
			// 	this.beginGetMoreAiContent();
			// } else {
			// 	// this.beginGetAiContent();
			// 	this.startGetAiContent();
			// }
			this.startGetAiContent();
		})
	},
	methods: {
		// 获取 Cookie
		getCookie(c_name) {
			var name = c_name + '=';
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = decodeURIComponent(ca[i].trim()); // 解码
				if (c.indexOf(name) == 0) {
					return JSON.parse(c.substring(name.length, c.length));
				}
			}
			return '';
		},
		// 帮我解读
		startGetAiContent() {
			let protocol = window.location.protocol;
			let hostname = window.location.hostname;
			let port = window.location.port ? ':' + window.location.port : ''; // 如果端口号不是默认，则添加':'和端口号
			let whole = protocol + '//' + hostname + port;

			// 创建 EventSource 对象
			const eventSource = new EventSourcePolyfill(
				// 'http://192.168.1.16:9527' + '/api/sse/createConnect',
				// 'http://localhost:8081/api' + '/api/sse/createConnect',
				// 'http://localhost:8081' + '/api/sse/createConnect',
				// this.$store.state.baseUrl + '/api' + '/api/sse/createConnect',
				// this.$store.state.baseUrl + '/api/sse/createConnect', 
				whole + (port.indexOf(':80') >= 0 ? '/api' : '') + '/api/sse/createConnect',
				{
					headers: {
						'Authentication': this.getCookie('userInfo').token
					}
				}
			);

			this.eventSource = eventSource;
			// 监听 - 服务器发送的事件
			let that = this;
			eventSource.onmessage = function(event) {
				// console.log('SSE - 收到消息 - ', event.data);

				let data = JSON.parse(event.data);
				// data.data = '首先，用户提供了睡眠报告的数据，我需要根据技能1来解读这份报告。报告包括四个维度：作息、呼吸、心跳和睡眠质量。\n\n关键数据：\n- **作息**：上床时间21:12，入睡时间21:17，醒来时间05:49，起床时间05:54。睡眠时长482分钟（约8小时）。\n- **呼吸**：最大呼吸率20，最小8，平均15，呼吸异常指数0，睡眠呼吸暂停次数和长度没有数据（显示为“-”）。\n- **心跳**：最大心率54，最小45，平均47。\n- **睡眠质量**：起夜次数0，深睡时长98分钟（占比20%），体动指数7.26次/小时，睡眠得分94。\n\n现在，我需要根据知识库的内容来解读每个维度：\n- **作息分析**：\n  - 上床到入睡时间很短（5分钟），表明入睡快。\n  - 睡眠时长8小时，在正常范围（6-10小时）。\n  - 起夜次数0，在健康标准（0-2次）。\n  - 作息规律：晚上21:17入睡，早上05:49醒来，符合健康作息。\n  - 参考：晚于23:00入睡可能有问题，但这里早于23:00，正常。\n- **呼吸监测**：\n  - 平均呼吸率15，在正常范围（8-22次/分钟）。\n  - 呼吸异常指数0，表示没有呼吸暂停事件（知识库：呼吸异常指数超过5表示风险，0是理想）。\n  - 睡眠呼吸暂停次数和长度没有数据（“-”），可能表示没有事件。\n  - 参考：呼吸异常指数0 <5，安全。\n- **心跳监测**：\n  - 平均心率47，最小心率45，最大54。\n  - 知识库：睡眠心率正常范围40-100，50上下正常。这里47在正常范围内。\n  - 心率平稳，没有过速或过缓。\n- **睡眠质量**：\n  - 起夜次数0，理想。\n  - 深睡时长98分钟，占比20%，在参考值（20%-60%）内，健康。\n  - 体动指数7.26次/小时，在参考值（1.25-15）内，正常。\n  - 睡眠得分94，非常高，表明睡眠质量好。\n  - 其他：睡眠效率未直接给出，但从数据看，应该高（起夜0，入睡快）。\n\n整体评估：\n- 所有维度都在健康范围内。\n- 没有异常指标。\n- 睡眠得分94很高。\n\n评分：\n- 作息：⭐️⭐️⭐️⭐️⭐️（完美）\n- 呼吸：⭐️⭐️⭐️⭐️⭐️（安全）\n- 心跳：⭐️⭐️⭐️⭐️⭐️（正常）\n- 睡眠质量：⭐️⭐️⭐️⭐️⭐️（优秀）\n- 综合结论：5星，健康睡眠。\n\n健康建议：\n- 由于所有指标良好，不需要推荐医疗器械或服务。\n- 可以鼓励保持良好习惯。\n- 根据技能2，对于健康状态好的老人，回答可以轻松可爱一点。\n\n输出格式：\n- 开头：## ✨清小雷为您解读睡眠报告✨（满分5星）\n- 小标题：### 🌜作息分析、### 🌬️呼吸监测、### 💓心跳监测、### 🛌睡眠质量、### 🌿综合结论\n- 每个部分用星星评分，加表情符号。\n- 综合结论给出整体评分和建议。\n- 结尾：猜你想问：三个问题用\" QingleiSplitAsk\"分隔。\n\n猜你想问：\n- 基于报告，可能的问题：深睡占比20%如何维持？体动指数7.26正常吗？睡眠得分94分算好吗？\n- 确保问题简洁。\n\n完整输出：\n- 作息分析：强调规律作息，睡眠时长好。\n- 呼吸监测：呼吸平稳，无风险。\n- 心跳监测：心率正常。\n- 睡眠质量：优秀得分。\n- 综合结论：整体健康，建议保持。\n\n字数限制：单个报告解读不超过600字，其他回答不超过400字。这个应该简洁。\n\n最终输出结构：\n1. 开头标题\n2. 作息分析\n3. 呼吸监测\n4. 心跳监测\n5. 睡眠质量\n6. 综合结论\n7. 猜你想问QingleiSplitThought## ✨清小雷为您解读睡眠报告✨（满分5星）  \n### 🌜作息分析 ⭐️⭐️⭐️⭐️⭐️  \n您的作息非常规律！21:17入睡→05:49醒来，睡眠时长约8小时（健康范围6-10小时），起夜0次（完美达标0-2次标准）。入睡快（仅5分钟），像钟表一样精准⏰，建议继续保持！  \n\n### 🌬️呼吸监测 ⭐️⭐️⭐️⭐️⭐️  \n呼吸平稳无忧！平均呼吸率15次/分钟（正常范围8-22），呼吸异常指数0（无风险），如同夜间“顺畅的风箱”🍃，无呼吸暂停事件。  \n\n### 💓心跳监测 ⭐️⭐️⭐️⭐️⭐️  \n心脏状态极佳！平均心率47次/分（睡眠正常范围40-100），最小心率45显示心脏休息充分，波动平稳（45-54），像安静的溪流💧。  \n\n### 🛌睡眠质量 ⭐️⭐️⭐️⭐️⭐️  \n睡眠质量优秀！深睡占比20%（健康范围20%-60%），体动指数7.26次/小时（正常范围1.25-15），睡眠得分94分（高分），起夜0次，整体像“安稳的摇篮”🛏️。  \n\n### 🌿综合结论  \n健康睡眠模范（5星）！🎉 您像一棵茁壮的大树🌳，所有指标均在理想范围：  \n1️⃣ 保持规律作息，避免睡前刺激（如咖啡）  \n2️⃣ 向养老院咨询放松活动（如轻柔拉伸）  \n3️⃣ 定期监测睡眠，巩固好习惯  \n\n猜你想问：深睡占比20%如何保持？QingleiSplitAsk 体动指数7.26正常吗？QingleiSplitAsk 睡眠得分94分算好吗？'

				// 是否完成
				if (data && data.status && data.status == 'done') {
					that.wholeContent = data.data;
					that.isDataFull = true;
					that.eventSource.close(); // 客户端调用close方法来关闭连接
				}

				that.$emit('update:modelValue', data.sessionId);

				if (!that.isRequestServerInterface) {
					that.isRequestServerInterface = true;
					that.requestServerInterface(data.clientId);
				} else {
					that.isLoading = false;

					if (data.data) {
						marked.use({
							mangle: false,
							headerIds: false
						});
						let content = data.data || '';
						// content = that.deleteAsking(data.data || '')
						// 将小波浪号替换为大波浪号,解决删除线的问题
						let dealContent = content.replace(/~/g, "～")

						that.rawContent = dealContent || '';
						
					}

					if (!that.isPrint) {
						that.isPrint = true;
						that.startTypewriterEffect();
					}
				}

			};
			// 监听 - 服务器关闭连接的事件
			eventSource.onclose = function(e) {
				console.log('SSE - 连接已关闭', e);
			};
			// 监听 - 服务器错误事件
			eventSource.onerror = function(e) {
				console.log('SSE - 连接出错', e);
			};
			// 监听 - 连接成功
			eventSource.addEventListener('open', (e) => {
				console.log('SSE - Open - 连接成功', e)
			})
			// 监听 - 收到自定义消息
			eventSource.addEventListener('message', e => {
				// console.log('SSE - Message - 收到自定义消息', e)
			})
			// 监听 - 出错了
			eventSource.addEventListener('error', e => {
				console.log('SSE - Error - 出错了', e)
			})
		},
		// 请求服务器的 SSE 推送接口
		requestServerInterface(clientId) {
			console.log('=========', this.$props.dataIndex, this.$props.data)
			// if (this.$props.data.text && this.$props.data.text != '帮我解读“当日需及时关心的长者”') {
			if (this.$props.dataIndex != 2 || this.$props.isRandom == true) {
				this.isLoading = true
				this.$get(
					'/api/healthReportAi/askStreamDS', 
					// 'http://192.168.1.16:9527/api/dean/ai/timelyCareElderAiAskStream', 
					{
						clientId: clientId,
						sessionId: this.$props.modelValue,
						question: this.$props.data.text || ''
					},
					(res) => {
						if (res.code == 0) {
						} else {
							this.isLoading = false;
							this.$emit(
								'requestFinish'
							);
						}
					},
					(err) => {
						this.isLoading = false;
						this.$emit(
							'requestFinish'
						);
					}
				);
			} else {
				this.isLoading = true
				this.$get(
					'/api/healthReportAi/singleStreamDS', 
					// 'http://192.168.1.16:9527/api/dean/ai/timelyCareElderAiStream', 
					{
						clientId: clientId,
						bedId: this.$props.data.data.bedId,
						date: this.$props.data.data.paramDate
					},
					(res) => {
						if (res.code == 0) {
							this.$emit(
								'changeShareTitle', 
								res.data.shareTitle ? res.data.shareTitle : '清雷AI助手'
							);
						} else {
							this.isLoading = false;
						}
					},
					(err) => {
						this.isLoading = false;
					}
				);
			}
		},
		// 开启打字效果
		startTypewriterEffect() {
			if (this.interval) {
				clearInterval(this.interval);
			}
			this.interval = setInterval(() => {

				let showTextContent = this.rawContent.substring(0, this.index);

				let normalShowTextContent = showTextContent;

				// 2.通过单日报告 + 深度思考的标记拆分成数组
				let needArr = [];
				let needDeepThinkingIsUnfoldArr = JSON.parse(JSON.stringify(this.deepThinkingIsUnfoldArr));
				let splitArr = normalShowTextContent.split("QingleiSplitThought");
				if (splitArr && splitArr.length > 0) {
					if (splitArr.length == 1 && splitArr[0] == '') {
						this.displayedContentArr = null;
						this.deepThinkingIsUnfoldArr = [];
					} else {
						for (let i = 0; i < splitArr.length; i++) {
							let item = splitArr[i];
							if (i % 2 == 0) { // 深度思考
								needArr.push({
									isDepth: true,
									content: marked.parse(item),
									isFinishDepth: i == splitArr.length - 1 ? false : true
								});
								if (needArr.length > needDeepThinkingIsUnfoldArr.length) {
									needDeepThinkingIsUnfoldArr.push('have');
								}
							} else { // 正文
								needArr.push({
									isDepth: false,
									content: marked.parse(this.deleteAsking(item || '')),
									isFinishDepth: i == splitArr.length - 1 ? false : true
								});
								if (needArr.length > needDeepThinkingIsUnfoldArr.length) {
									needDeepThinkingIsUnfoldArr.push(null);
									if (needDeepThinkingIsUnfoldArr[needDeepThinkingIsUnfoldArr.length - 2] == 'have') {
										needDeepThinkingIsUnfoldArr[needDeepThinkingIsUnfoldArr.length - 2] = 'fold'
									}
								}
							}
						}
						this.displayedContentArr = needArr;
						this.deepThinkingIsUnfoldArr = needDeepThinkingIsUnfoldArr;
					}
				} else {
					this.displayedContentArr = null;
					this.deepThinkingIsUnfoldArr = [];
				}




				if (this.index < this.rawContent.length) {
					this.index = this.index + 1;
				} else {
					if (this.isDataFull == true) {
						let tempWholeContent = '';
						if (this.wholeContent.indexOf('QingleiSplitThought') >= 0) {
							let tempWholeContentArr = this.wholeContent.split('QingleiSplitThought');
							tempWholeContent = tempWholeContentArr[tempWholeContentArr.length - 1];
						} else {
							tempWholeContent = this.wholeContent;
						}
						this.analysisAsking(tempWholeContent);
						this.isFinish = true;
						clearInterval(this.interval);
						this.$emit(
							'requestFinish'
						);
						if (this.$props.dataIndex == 2) {
							let normalText = this.getNormalText(this.rawContent);
							let needResult = normalText.substring(0, 60);
							this.$emit(
								'changeShareSubTitle', 
								needResult
							);
						}
						this.$emit(
							'changeMsgArr', 
							{
								"content": this.deleteAsking(this.rawContent)
							}, 
							this.$props.dataIndex
						);
						// 打字完成了的回调用
						this.$emit(
							'typewritingFinish'
						);
					} else {
						// this.displayedContent = marked.parse(this.rawContent.substring(0, this.index) + '<div class="myClass">AI分析中,请稍候...</div>'); // + '<div class="myClass">...</div>'
					}
				}
			}, 30); // 每100毫秒添加一个字符
		},
		// 解析 - 猜你想问
		analysisAsking(str) {
			// str = JSON.stringify(str).toString();
			console.log('===猜你想问解析===', str)
			
			let conditionArr = [
				'\n\n### 猜你想问：\n',
				'\n\n### 猜你想问：',
				'\n\n猜你想问：\n',
				'\n\n猜你想问：',
				'\n\n### 猜你想问\n',
				'\n\n### 猜你想问',
				'\n\n猜您想问：\n',
				'\n\n猜您想问：',
				'\n猜你想问：\n',
				'\n猜你想问：',
				'### 猜你想问：\n',
				'### 猜你想问：',
				'### 猜你想问\n',
				'### 猜你想问',
				'猜你想问：\n',
				'猜你想问：'
			];

			if (str) {

				let matchingString = null;

				for (let i = 0; i < conditionArr.length; i++) {
					if (str.indexOf(conditionArr[i]) >= 0) {
						if (!matchingString) {
							matchingString = conditionArr[i];
						}
					}
				}


				if (matchingString) {
					let arr = str.split(matchingString);
					if (arr && arr.length == 2) {
						let item = arr[1];
						let arr1 = item.split("QingleiSplitAsk");
						if (arr1 && arr1.length > 0) {
							this.questions = arr1;
						}
					}
				}

			}
		},
		// 删除多余的猜你想问
		deleteAsking(str) {

			let dealStr;
			let needString = '';
			if (str.indexOf('QingleiSplitThought') >= 0) {
				let splitArr = str.split("QingleiSplitThought");
				if (splitArr && splitArr.length > 0) {
					
					for (let i = 0; i < splitArr.length; i++) {
						if (i == splitArr.length - 1) {
							dealStr = 'QingleiSplitThought' + splitArr[i];
						} else {
							needString = needString + (i > 0 ? 'QingleiSplitThought' + splitArr[i] : splitArr[i])
						}
					}
				} else {
					dealStr = str;
				}
			} else {
				dealStr = str;
			}

			let conditionArr = [
				'\n\n### 猜你想问：\n',
				'\n\n### 猜你想问：',
				'\n\n猜你想问：\n',
				'\n\n猜你想问：',
				'\n\n### 猜你想问\n',
				'\n\n### 猜你想问',
				'\n\n猜您想问：\n',
				'\n\n猜您想问：',
				'\n猜你想问：\n',
				'\n猜你想问：',
				'### 猜你想问：\n',
				'### 猜你想问：',
				'### 猜你想问\n',
				'### 猜你想问',
				'猜你想问：\n',
				'猜你想问：'
			];


			if (dealStr) {

				let matchingString = null;

				for (let i = 0; i < conditionArr.length; i++) {
					if (dealStr.indexOf(conditionArr[i]) >= 0) {
						if (!matchingString) {
							matchingString = conditionArr[i];
						}
					}
				}

				if (matchingString) {
					let arr = dealStr.split(matchingString);
					if (arr && arr.length == 2) {
						let needStr = arr[0];
						return needString + needStr;
					}
				} else {
					return needString + dealStr;
				}

			}
			return needString + dealStr;
		},
		// 点击猜你想问中的某个问题
		clickAiQuestion(item) {
			this.$emit(
				'clickAiAnalysis', 
				item
			);
		},
		// 点击拷贝AI内容文本
		clickCopyText() {
			let markdownString = this.deleteAsking(this.rawContent);
			const html = marked(markdownString); // 使用marked转换Markdown到HTML
			let text = html.replace(/<\/?[^>]+(>|$)/g, ''); // 使用正则表达式去掉HTML标记

			let textarea = document.createElement("textarea");
			textarea.value = text;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
			this.toastStr = '复制成功';
			setTimeout(() => {
				this.toastStr = null;
			}, 2000);
		},
		// 获取正常的文本
		getNormalText(str) {
			let markdownString = str;
			const html = marked(markdownString); // 使用marked转换Markdown到HTML
			let text = html.replace(/<\/?[^>]+(>|$)/g, ''); // 使用正则表达式去掉HTML标记

			return text
		},
		// 点击分享
		share() {
			console.log('===msgArr===',  this.$props.msgArr)
			if (this.isShowQrCode) {
				this.isShowQrCode = !this.isShowQrCode;
				let container = document.getElementById('qrCode');
				container.innerHTML = '';
			} else {
				this.$post(
					'/api/dean/ai/timelyCareElderShare',
					{
						"msgArr": this.$props.msgArr,
						"showLastIndex": this.$props.dataIndex,
						"shareTitle": this.$props.shareTitle,
						"shareSubTitle": this.$props.shareSubTitle
					},
					(res) => {
						if (res.code == 0) {
							let shareJsonUrl = res.data || '';
							console.log('===分享链接===', shareJsonUrl)
							this.isShowQrCode = !this.isShowQrCode;
							this.$nextTick(function () {
								this.bindQRCode(shareJsonUrl);
							});
						} else {
						}
					},
					(err) => {
						console.log(err);
						// this.$message.error('服务端发生异常');
					}
				);
			}
		},
		// 生成二维码
		bindQRCode: function (params) {
			this.qrCodeIsLoading = true;
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDetails, {
					// text: 'http://localhost:8080/#/aiShare?jsonUrl=https%3A%2F%2Fql-hospital-test.oss-cn-beijing.aliyuncs.com%2Fpub%2Ffile%2Feeg%2FADT_R20240814153930.json',
					text: this.$store.state.baseUrl + '/#/aiShare?jsonUrl=' + params,
					width: 160,
					height: 160,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.qrCodeIsLoading = false;
			}, 1000);
		},
		// 点击了折叠按钮
		clickUnflod() {
			this.isUnfold = !this.isUnfold;
		},
		// 点击了折叠按钮
		clickUnflod1(index) {
			let tempDeepThinkingIsUnfoldArr = JSON.parse(JSON.stringify(this.deepThinkingIsUnfoldArr));
			let type = tempDeepThinkingIsUnfoldArr[index];
			if (!type) {
				return
			}
			if (type == 'unfold' || type == 'have') {
				tempDeepThinkingIsUnfoldArr[index] = 'fold';
			} else {
				tempDeepThinkingIsUnfoldArr[index] = 'unfold';
			}
			this.deepThinkingIsUnfoldArr = tempDeepThinkingIsUnfoldArr;
		},








		
		
		// 请求下一个 AI 接口
		requestNexAiContent(list) {
			if (list && list.length > 0) {
				// 1.请求接口
				this.$get(
					'/api/dean/ai/timelyCareElderAiSingle', {fileId: list[0]},
					(res) => {
						if (res.code == 0) {

							// 2.获取到的数据
							let choicesMessage = res.data;

							this.jsonArr.push(choicesMessage);

							// 4.通过Json路径获取相应的数据
							axios({
								method: 'get',
								url: choicesMessage || '',
								headers: {
									'Content-Type': 'application/json',
									'Cache-Control': 'no-cache',
									'Pragma': 'no-cache'
								},
							})
							.then((response) => {
								let content = response ? response.content : '';
								content = this.deleteAsking(response ? response.content : '')
								// 将小波浪号替换为大波浪号,解决删除线的问题
								let dealContent = content.replace(/~/g, "～")

								// 5.更新打印的字符串
								this.rawContent = this.rawContent + '\n\n' + content;
								this.displayedContent = marked(this.rawContent);
								this.startTypewriterEffect();

								// 6.处理 list 数组，紧接着请求下一个接口
								let copyList = JSON.parse(JSON.stringify(list));
								let newList = copyList.splice(1);
								if (newList && newList.length > 0) {
									this.requestNexAiContent(newList);
								} else {
									console.log('回传', this.jsonArr)
									// 3.回传给分享所需的数据链接
									this.$emit(
										'changeMsgArr', 
										{
											"jsonUrlArr": this.jsonArr,
											"jsonType": 'array'
										}, 
										this.$props.dataIndex
									);

									this.isFinish = true;
									this.analysisString = response ? response.content : '';
									this.$emit(
										'requestFinish'
									);
								}
							})
							.catch(() => {
								this.$emit(
									'requestFinish'
								);
							});
						} else {
							this.$emit(
								'requestFinish'
							);
						}
					},
					(err) => {
						this.$emit(
							'requestFinish'
						);
					}
				);
			}
		},
		// AI搜索 - 输入框用户自定义的
		aiSearch(text) {
			this.$emit(
				'clickAiAnalysis', 
				text
			);
		},
		// 停止请求
		stopPrint() {
			this.isStopPrint = true;
			this.isDataFull = true;
			this.eventSource.close(); // 客户端调用close方法来关闭连接
			if (this.interval) {
				clearInterval(this.interval);
			}
			// 打字完成了的回调用
			this.$emit(
				'typewritingFinish',
				this.pageData
			);
		}
	},
};
</script>
<style lang="scss" scoped>

.copy_share {
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_6.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_8.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
}

.copy_share_copyBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_copoyImage {
		background: url("../../assets/icon_home_ai_icon_7.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_copyText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

.copy_share_shareBtn:hover {
	background: rgba(105, 145, 232, 0.2);
	.copy_share_shareImage {
		background: url("../../assets/icon_home_ai_icon_9.png") no-repeat !important;
		background-size: 16px 16px !important;
	}
	.copy_share_shareText {
		color: rgba(74, 124, 232, 1) !important;
	}
}

::v-deep .loadingContent {
	.el-loading-spinner {
		margin-top: -35px !important;
	}
}

.deepThinking {
	margin-left: 20px;
	margin-right: 20px;
	margin-top: 0px;
	display: flex;
	flex-direction: column;
	background: rgba(94, 103, 121, 0.05);
	border-radius: 8px;
}

.deepThinking:hover {
	background: rgba(94, 103, 121, 0.1);
}



</style>

<style>
.myClass {
	display: inline-block !important;
	color: rgba(74, 124, 232, 1) !important;
}
</style>